import { render, staticRenderFns } from "./purchasePage.vue?vue&type=template&id=0fd66c2c&scoped=true&"
import script from "./purchasePage.vue?vue&type=script&lang=js&"
export * from "./purchasePage.vue?vue&type=script&lang=js&"
import style0 from "./purchasePage.vue?vue&type=style&index=0&id=0fd66c2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd66c2c",
  null
  
)

export default component.exports